import clsx from 'clsx';
export function Divider({ vertical, className }: { vertical?: boolean; className?: string }) {
  return <div className={clsx(vertical ? 'w-px h-full hairline-l' : 'h-px w-full hairline-t', className)} />;
}
